import React from "react";
import classes from "./Row.module.css";


//This component is just a div with display:flex, direction: row, and width of 100% 
//used in OurWork to display icons next to text
const Row = (props) => {

  return (
    <div className={classes.row} ref={props.inputRef} >{props.children}</div>
  );
};
export default Row;
